import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import "./Login.css";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Backdrop, CircularProgress } from "@mui/material";
import errorMessages from "../../utils/errorMessagesUtil";
import { useForm } from "react-hook-form";
import { useAppProviderStore } from "store/appProviderCopyStore";
import { useNotification } from "hooks/useNotification";


function ConfirmLoginPage() {
  const navigate = useNavigate();

  const { cognitoUserChangePassword } = useAppProviderStore();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [newPassword, setnewPassword] = useState("");
  const { setNotify } = useNotification();

  //input password 1
  const [showPassword1, setShowPassword1] = React.useState(false);
  const handleClickShowPassword1 = () => setShowPassword1((show) => !show);
  const handleMouseDownPassword1 = (event) => {
    event.preventDefault();
  };

  //input password 2
  const [showPassword2, setShowPassword2] = React.useState(false);
  const handleClickShowPassword2 = () => setShowPassword2((show) => !show);
  const handleMouseDownPassword2 = (event) => {
    event.preventDefault();
  };

  const backToLogin = async () => {
    try {
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  const completeNewPassword = async () => {
    setIsLoading(true);
    try {
      await Auth.completeNewPassword(
        cognitoUserChangePassword, // the Cognito User Object - not email
        newPassword
      );
      navigate("/login");
      setIsLoading(false);
    } catch (err) {
      console.log(err);
      setNotify({
        isOpen: true,
        message: errorMessages[err.message],
        type: "error",
        title: "Ops! Algo deu errado..."
      })
      setIsLoading(false);
    }
  };
  const enterPresskey = (event) => {
    if (event.keyCode === 13) {
      completeNewPassword()
    }
  }

  const {
    register,
    formState: { errors },
    trigger,
  } = useForm();


  return (
    <div className="container_login" style={{ backgroundImage: "url(/img/bg-login.png)" }}>
      <div className="line_header_login"></div>
      <div className="login">
        <div className="login_logo">
          <img src="/img/Logo_SescDigital_Pos.svg" alt="Logo" className="login_image" />
        </div>
        <div className="login_form">
          <div className="login_form_items">
            <p className="login_form_titulo">Redefinir Senha</p>
            <div className="real_form">
              <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
                <CircularProgress color="inherit" />
              </Backdrop>
              <Box sx={{ lg: 1, width: "100%" }} onKeyDown={(e) => enterPresskey(e)}>
                <FormControl sx={{ lg: 1, width: "90%", marginBottom: "5%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password1">Nova Senha</InputLabel>
                  <Input
                    id="standard-adornment-password1"
                    type={showPassword1 ? "text" : "password"}
                    name="password"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword1} onMouseDown={handleMouseDownPassword1}>
                          {showPassword1 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                    {...register("password", {
                      onChange: (e) => { setPassword(e.target.value); trigger(e.target.name) },
                      required: true,
                      pattern:
                        /(?=^.{8,}$)((?=.)(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/
                    })}
                    aria-invalid={errors.password ? "true" : "false"}
                    onBlur={(evt) => { trigger(evt.target.name) }}
                  />
                  {errors.password?.type === "required" && (
                    <p className="authFormError" role="alert">
                      Campo obrigatório.
                    </p>
                  )}
                  {errors.password?.type === "pattern" && (
                    <p className="authFormError" role="alert">
                      Requisitos mínimos: 8 digitos, 1 caractere especial, 1 letra maiúscula e minúscula.
                    </p>)}
                </FormControl>

                <FormControl sx={{ lg: 1, width: "90%" }} variant="standard">
                  <InputLabel htmlFor="standard-adornment-password2">Confirmar Nova Senha</InputLabel>
                  <Input
                    id="standard-adornment-password2"
                    type={showPassword2 ? "text" : "password"}
                    name="newPassword"
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword2} onMouseDown={handleMouseDownPassword2}>
                          {showPassword2 ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }

                    {...register("newPassword", {
                      onChange: (e) => { setnewPassword(e.target.value); trigger(e.target.name) },
                      required: true,
                      validate: (value) => value === password
                    })}
                    aria-invalid={errors.newPassword ? "true" : "false"}
                    onBlur={(evt) => trigger(evt.target.name)}
                  />
                  {errors.newPassword?.type === "required" && (
                    <p className="authFormError" role="alert">
                      Campo obrigatório.
                    </p>
                  )}
                  {errors.newPassword?.type === "validate" && (
                    <p className="authFormError" role="alert">
                      Senha diferente.
                    </p>)}
                </FormControl>
              </Box>
            </div>
            <div className="login_button">
              <button className="login_button_style" onClick={completeNewPassword}>
                Confirmar
              </button>
            </div>
            <div className="login_forgot_password">
              <a className="login_forgot_password_text" onClick={backToLogin}>
                Voltar para o Log in
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="line_bottom_login"></div>
    </div>
  );
}

export default ConfirmLoginPage;
